import BasePage from "./subBasePage";

export default class Page2Index extends BasePage{
    constructor(info){
        super(info);
        super.set();

        this.ele = info.ele;
        this.pageTl = new TimelineMax({ paused: true, ease: Power2.easeOut });
        this.flag = false;
        this._pageSet();
        this._bindEvent();
    }

    _pageSet(){
        this.pageTl
            .fromTo( this.ele.querySelector('.tit span'), 1, { y: "100%", autoAlpha: 1 }, { y: "0%", autoAlpha: 1, delay: 0.4, ease: Back.easeOut.config(1.05) })
            .fromTo( this.ele.querySelector('.txt-1'), 0.5, { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, "-=0.7")
            .fromTo( this.ele.querySelector('.char-1'), 1, { scale: 1, y: -100, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, "-=0.15")
            .fromTo( this.ele.querySelector('.char-2'), 1, { scale: 1, y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, "-=0.5")
            .fromTo( this.ele.querySelector('.char-3'), 1, { scale: 1, y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, "-=0.75")

            .addLabel('effect', '-=0.3')
            .fromTo( this.ele.querySelector('.char-1 .effect-1'), 0.5, { scale: 0.5, autoAlpha: 0 }, { scale: 1, autoAlpha: 0.7, ease: Back.easeOut }, "effect")
            .fromTo( this.ele.querySelector('.char-1 .effect-2'), 0.5, { scale: 1.5, autoAlpha: 0 }, { scale: 1, autoAlpha: 0.5, ease: Back.easeOut }, "-=0.47")

            .fromTo( this.ele.querySelector('.char-2 .effect-1'), 0.5, { y: -20, x: 80, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1, ease: Power4.easeOut }, "effect")
            .fromTo( this.ele.querySelector('.char-2 .effect-2'), 0.5, { y: -20, x: 80, scale: 1.5, autoAlpha: 0 }, { scale: 1, y: 0, x: 0, autoAlpha: 1, ease: Back.easeOut }, "-=0.47")

            .fromTo( this.ele.querySelector('.char-3 .effect-1'), 0.5, { y: 80, x: -20, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1, ease: Power4.easeOut }, "effect")
            .fromTo( this.ele.querySelector('.char-3 .effect-2'), 0.5, { y: 60, x: -20, scale: 1.5, autoAlpha: 0 }, { y: 0, x: 0, scale: 1, autoAlpha: 1, ease: Back.easeOut, onComplete: ()=>{ this.flag = true;} }, "-=0.47")
    }

    _pageMotion(){
        this.pageTl.restart();
    }

    _hide(){
        setTimeout(()=>{
            this.pageTl.reverse();
            this.flag = false;
            if( this.evtTarget ){
                TweenMax.set(this.evtTarget, { scale: 1, zIndex: 0 });
                this.evtTarget = '';
            }
        }, 500)
    }

    _bindEvent(){
        this.ele.addEventListener('onComplete', this._pageMotion.bind(this) );
        this.ele.addEventListener('hideComplete', this._hide.bind(this) );

        $( this.ele ).find('.list button').on('mouseenter', (e)=>{
            this.lastTime = 0;
            if( this.flag && new Date().getTime()-this.lastTime > 300 ){
                if( $(e.target).closest('li').index() == 0 ){
                    TweenMax.fromTo( this.ele.querySelector('.char-1 .bg-2'), 0.2, { y: 20, x: 20, }, { y: 0, x: 0,  ease: Power0.easeNone });
                    TweenMax.fromTo( this.ele.querySelector('.char-1 .effect-1'), 0.5, { scale: 0.5, autoAlpha: 0 }, { scale: 1, autoAlpha: 0.7, ease: Back.easeOut })
                    TweenMax.fromTo( this.ele.querySelector('.char-1 .effect-2'), 0.5, { scale: 1.5, autoAlpha: 0 }, { scale: 1, autoAlpha: 0.5, ease: Back.easeOut }, "-=0.47")
                    // TweenMax.fromTo( this.ele.querySelector('.char-1 .circle'), 0.2, { scale: 0.3, rotation: 0, autoAlpha: 0.5}, { scale: 1, rotation: 360, autoAlpha: 1 })
                }
                else if( $(e.target).closest('li').index() == 1 ){
                    TweenMax.fromTo( this.ele.querySelector('.char-2 .bg-2'), 0.2, { y: 20, x: -20, }, { y: 0, x: 0,  ease: Power0.easeNone });
                    TweenMax.fromTo( this.ele.querySelector('.char-2 .effect-1'), 0.5, { y: -20, x: 80, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1, ease: Power4.easeOut });
                    TweenMax.fromTo( this.ele.querySelector('.char-2 .effect-2'), 0.5, { y: -20, x: 80, scale: 1.5, autoAlpha: 0 }, { scale: 1, y: 0, x: 0, autoAlpha: 1, ease: Back.easeOut }, "-=0.47")
                    // TweenMax.fromTo( this.ele.querySelector('.char-2 .circle'), 0.2, { scale: 0.3, rotation: 0, autoAlpha: 0.5}, { scale: 1, rotation: 360, autoAlpha: 1 })
                }
                else if( $(e.target).closest('li').index() == 2 ){
                    TweenMax.fromTo( this.ele.querySelector('.char-3 .bg-2'), 0.2, { y: -20, x: 20, }, { y: 0, x: 0,  ease: Power0.easeNone });
                    TweenMax.fromTo( this.ele.querySelector('.char-3 .effect-1'), 0.5, { y: 80, x: -20, autoAlpha: 0 }, { y: 0, x: 0, autoAlpha: 1, ease: Power4.easeOut });
                    TweenMax.fromTo( this.ele.querySelector('.char-3 .effect-2'), 0.5, { y: 60, x: -20, scale: 1.5, autoAlpha: 0 }, { y: 0, x: 0, scale: 1, autoAlpha: 1, ease: Back.easeOut }, "-=0.47")
                    // TweenMax.fromTo( this.ele.querySelector('.char-3 .circle'), 0.2, { scale: 0.3, rotation: 0, autoAlpha: 0.5}, { scale: 1, rotation: 360, autoAlpha: 1 })
                }
                this.lastTime = new Date().getTime();
            }
        });

        $( this.ele ).find('.list button').on('click', (e)=>{
            this.evtTarget = $(e.target).closest('li');
            TweenMax.to( $(e.target).closest('li'), 1, { scale: 2, zIndex: 11, ease: Power2.easeOut } );
        });
    }

    show(){
        super.show();
    }
}


// WEBPACK FOOTER //
// ./src/js/subDeath/page2_index.js